import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
// material
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { useMediaQuery, Divider, IconButton } from '@material-ui/core';
//
import ChatRoomGroupParticipantSignWise from './ChatRoomGroupParticipantSignWise';
import ChatRoomOneParticipantSignWise from './ChatRoomOneParticipant';
import ChatRoomAttachmentSignWise from './ChatRoomAttachmentSignWise';
import GroupChatSettings from './GroupChatSettings';
import Scrollbar from 'src/components/Scrollbar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  width: 240,
  flexShrink: 0,
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  borderLeft: `solid 1px ${theme.palette.divider}`,
  transition: theme.transitions.create('width')
}));

const ToggleButtonStyle = styled('div')(({ theme }) => ({
  borderRight: 0,
  display: 'flex',
  overflow: 'hidden',
  position: 'absolute',
  alignItems: 'center',
  top: theme.spacing(1),
  left: theme.spacing(-4),
  width: theme.spacing(4),
  height: theme.spacing(4),
  justifyContent: 'center',
  boxShadow: theme.customShadows.z8,
  border: `solid 1px ${theme.palette.divider}`,
  borderTopLeftRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  borderBottomLeftRadius: theme.shape.borderRadius
}));

// ----------------------------------------------------------------------

ChatRoomSignWise.propTypes = {
  conversation: PropTypes.object.isRequired,
  participants: PropTypes.array.isRequired
};

export default function ChatRoomSignWise({ conversation,handleRefresh, participants,openSidebar,setOpenSidebar, setSelectedContact, setCompose,  ...other }) {

  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [showInfo, setShowInfo] = useState(true);
  const [selectUser, setSelectUser] = useState(null);
  const [showAttachment, setShowAttachment] = useState(true);
  const [showParticipants, setShowParticipants] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [isGroup, setIsGroup] = useState(false)
  useEffect(() => {
    if (participants?.conversation_type === 'group') {
      setIsGroup(true)
    } else {
      setIsGroup(false)
    }
  }, [participants])

  useEffect(() => {
    if (isMobile) {
      return setOpenSidebar(false);
    }
    return setOpenSidebar(true);
  }, [isMobile]);

  return (
    <RootStyle
      sx={{
        ...(!openSidebar && {
          width: 0,
          '& > *': { overflow: 'hidden' }
        })
      }}
      {...other}
    >
      <ToggleButtonStyle>
        <IconButton onClick={() => setOpenSidebar(!openSidebar)}>
          <Icon width={16} height={16} icon={openSidebar ? arrowIosForwardFill : arrowIosBackFill} />
        </IconButton>
      </ToggleButtonStyle>
      
      <Scrollbar sx={{ flexGrow: 1, height: '100vh', overflowY: 'auto' }}>
        {isGroup ? (
          <>
            <ChatRoomGroupParticipantSignWise
              selectUserId={selectUser}
              participants={participants?.participants}
              isCollapse={showParticipants}
              onShowPopupUserInfo={(participantId) => setSelectUser(participantId)}
              onCollapse={() => setShowParticipants((prev) => !prev)}
              handleRefresh={handleRefresh}
            />        
            <Divider />
            <GroupChatSettings
            isGroup={isGroup}
            receiverId={participants?.user_id}
            openSidebar={openSidebar}
              handleRefresh={handleRefresh}
              selectUserId={selectUser}
              initialGrpName={participants?.group_name}
              conversationId={participants?.conversation_id}
              participants={participants?.participants}
              isCollapse={showSettings}
              onShowPopupUserInfo={(participantId) => setSelectUser(participantId)}
              onCollapse={() => setShowSettings((prev) => !prev)}
              setSelectedContact={setSelectedContact}
              setCompose={setCompose}
            />
          </>
        ) : (
          <>
            <ChatRoomOneParticipantSignWise
              participants={participants}
              isCollapse={showInfo}
              onCollapse={() => setShowInfo((prev) => !prev)}
            />
            <Divider />
            <GroupChatSettings
            singleChat={true}
            isGroup={isGroup}
            receiverId={participants?.user_id}
            openSidebar={openSidebar}
              handleRefresh={handleRefresh}
              selectUserId={selectUser}
              initialGrpName={participants?.group_name}
              conversationId={participants?.conversation_id}
              participants={participants?.participants}
              isCollapse={showSettings}
              onShowPopupUserInfo={(participantId) => setSelectUser(participantId)}
              onCollapse={() => setShowSettings((prev) => !prev)}
              setSelectedContact={setSelectedContact}
              setCompose={setCompose}
            />
          </>
        )}
        <Divider />

        <ChatRoomAttachmentSignWise
          conversation={conversation}
          isCollapse={showAttachment}
          onCollapse={() => setShowAttachment((prev) => !prev)}
        />
      </Scrollbar>
    </RootStyle>
  );
}
